import React from 'react';

const CounterContext = React.createContext();

export default CounterContext